import { Component } from '@angular/core';
import { IconUiIcon } from '@inshared/website-ui-components';
import { SalesfunnelRoutes } from '@app/salesfunnel/routing/salesfunnel-routing.routes';

@Component({
    selector: 'ins-insurances-list',
    templateUrl: './insurances-list.component.html',
})

export class InsurancesListComponent {
    public salesfunnelRoutes = SalesfunnelRoutes;

    public items: {
        icon: IconUiIcon,
        label: string,
        testId: string,
        route?: string[],
        url?: string,
    }[] = [
        {
            icon: 'car',
            label: 'Autoverzekering',
            testId: 'calculate-car-premium',
            route: ['/', SalesfunnelRoutes.CarInsurance, SalesfunnelRoutes.CalculateCarInsurance]
        },
        {
            icon: 'house',
            label: 'Woonverzekering',
            testId: 'calculate-home-premium',
            route: ['/', SalesfunnelRoutes.HomeInsurance, SalesfunnelRoutes.CalculateHomeInsurance]
        },
        {
            icon: 'pet',
            label: 'Dierenverzekering',
            testId: 'calculate-pet-premium',
            route: ['/', SalesfunnelRoutes.PetInsurance, SalesfunnelRoutes.CalculatePetInsurance]
        },
        {
            icon: 'moped',
            label: 'Brommerverzekering',
            testId: 'calculate-moped-premium',
            route: ['/', SalesfunnelRoutes.MopedInsurance, SalesfunnelRoutes.CalculateMopedInsurance]
        },
        {
            icon: 'bicycle',
            label: 'Fietsverzekering',
            testId: 'calculate-bike-premium',
            route: ['/', SalesfunnelRoutes.BicycleInsurance, SalesfunnelRoutes.CalculateBicycleInsurance]
        },
        {
            icon: 'legal',
            label: 'Aansprakelijkheid',
            testId: 'calculate-liability-premium',
            url: `/${SalesfunnelRoutes.LiabilityInsurance}/${SalesfunnelRoutes.CalculateLiabilityInsurance}`
        },
        {
            icon: 'holidays',
            label: 'Reisverzekering',
            testId: 'calculate-travel-premium',
            url: `/${SalesfunnelRoutes.TravelInsurance}/${SalesfunnelRoutes.CalculateTravelInsurance}`
        },
        {
            icon: 'caravan',
            label: 'Caravanverzekering',
            testId: 'calculate-caravan-premium',
            route: ['/', SalesfunnelRoutes.CaravanInsurance, SalesfunnelRoutes.CalculateCaravanInsurance]
        },
        {
            icon: 'law',
            label: 'Rechtsbijstand',
            testId: 'calculate-legal-assistance-premium',
            url: `/${SalesfunnelRoutes.LegalAssistance}/${SalesfunnelRoutes.CalculateLegalAssistance}`
        },
        {
            icon: 'damage',
            label: 'Ongevallenverzekering',
            testId: 'calculate-accidents-premium',
            url: `/${SalesfunnelRoutes.Accidents}/${SalesfunnelRoutes.CalculateAccidents}`
        },
        {
            icon: 'motorcycle',
            label: 'Motorverzekering',
            testId: 'calculate-motor-premium',
            route: ['/', SalesfunnelRoutes.MotorInsurance, SalesfunnelRoutes.CalculateMotorInsurance]
        },
    ];
}
